import { isMarketType, getDictPhrase } from "../../helpers";
export const getSelectionNameRegular = (props, market, selection) => {
    if (isMarketType(market.marketType.id, "HC") && !props.isDesktop) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML")
        && !props.showMLTeamName
        && selection.outcomeType !== null) {
        return getDictPhrase(props.dict, selection.outcomeType);
    }
    return selection.name;
};
//# sourceMappingURL=getSelectionNameRegular.js.map